import { db } from './firebaseSetup.js';
import { collection, query, onSnapshot, doc, setDoc, updateDoc, arrayUnion, deleteField, getDocs } from "firebase/firestore";

const queryEquiposInmaculadaA = query(collection(db, "ligas","inmaculadaA", "equipos"))
const queryEquiposInmaculadaB = query(collection(db, "ligas","inmaculadaB", "equipos"))
const queryEquiposInmaculadaFem = query(collection(db, "ligas","inmaculadaFem", "equipos"))

const queryJornadasInmaculadaA = query(collection(db, "ligas","inmaculadaA", "jornadas"))
const queryJornadasInmaculadaB = query(collection(db, "ligas","inmaculadaB", "jornadas"))
const queryJornadasInmaculadaFem = query(collection(db, "ligas","inmaculadaFem", "jornadas"))

const queryPatrocinadoresInmaculadaA = query(collection(db, "ligas","inmaculadaA", "patrocinadores"))
const queryPatrocinadoresInmaculadaB = query(collection(db, "ligas","inmaculadaB", "patrocinadores"))
const queryPatrocinadoresInmaculadaFem = query(collection(db, "ligas","inmaculadaFem", "patrocinadores"))

const partidoSiguienteInmaculadaA = doc(db, "partidoSiguiente", "inmaculadaA")
const partidoSiguienteInmaculadaB = doc(db, "partidoSiguiente", "inmaculadaB")
const partidoSiguienteInmaculadaFem = doc(db, "partidoSiguiente", "inmaculadaFem")


//FANTASY
const queryFantasyJugadores = query(collection(db, "fantasy","disponibles", "jugadores"))
const queryFantasyEquipos = query(collection(db, "fantasy","disponibles", "equipos"))
const queryFantasyParticipantes = query(collection(db, "fantasy","usuarios", "participantes"))
const queryFantasyConfig = doc(db, "fantasy", "config")


/**
* Obtener InmaculadaA Equipos
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getInmaculadaAEquipos(onSuccess, onError) {
    try {
        onSnapshot(queryEquiposInmaculadaA, (snapshot) => {
            const equipos = [];
            snapshot.forEach((doc) => {
                equipos.push(doc.data());
            });
            onSuccess(equipos)
        });
        
    } catch (error) {
        onError(null, error);
    }
}

/**
* Obtener InmaculadaB Equipos
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getInmaculadaBEquipos(onSuccess, onError) {
    try {
        onSnapshot(queryEquiposInmaculadaB, (snapshot) => {
            const equipos = [];
            snapshot.forEach((doc) => {
                equipos.push(doc.data());
            });
            onSuccess(equipos)
        });
        
    } catch (error) {
        onError(null, error);
    }
}

/**
* Obtener InmaculadaFem Equipos
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getInmaculadaFemEquipos(onSuccess, onError) {
    try {
        onSnapshot(queryEquiposInmaculadaFem, (snapshot) => {
            const equipos = [];
            snapshot.forEach((doc) => {
                equipos.push(doc.data());
            });
            onSuccess(equipos)
        });
        
    } catch (error) {
        onError(null, error);
    }
}

/**
* Obtener InmaculadaA partidoSiguiente
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getPartidoSiguienteInmaculadaA(onSuccess, onError) {
    try {
        onSnapshot(partidoSiguienteInmaculadaA, (doc) => {
            onSuccess(doc.data())
        });
    } catch (error) {
        onError(null, error);
    }
}

/**
* Obtener InmaculadaB partidoSiguiente
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getPartidoSiguienteInmaculadaB(onSuccess, onError) {
    try {
        onSnapshot(partidoSiguienteInmaculadaB, (doc) => {
            onSuccess(doc.data())
        });
    } catch (error) {
        onError(null, error);
    }
} 

/**
* Obtener InmaculadaFem partidoSiguiente
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getPartidoSiguienteInmaculadaFem(onSuccess, onError) {
    try {
        onSnapshot(partidoSiguienteInmaculadaFem, (doc) => {
            onSuccess(doc.data())
        });
    } catch (error) {
        onError(null, error);
    }
} 

/**
* Obtener InmaculadaA Jornadas
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getInmaculadaAJornadas(onSuccess, onError) {
    try {
        onSnapshot(queryJornadasInmaculadaA, (snapshot) => {
            const jornadas = [];
            snapshot.forEach((doc) => {
                jornadas.push(doc.data());
            });
            onSuccess(jornadas)
        });
        
    } catch (error) {
        onError(null, error);
    }
}

/**
* Obtener InmaculadaB Jornadas
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getInmaculadaBJornadas(onSuccess, onError) {
    try {
        onSnapshot(queryJornadasInmaculadaB, (snapshot) => {
            const jornadas = [];
            snapshot.forEach((doc) => {
                jornadas.push(doc.data());
            });
            onSuccess(jornadas)
        });
        
    } catch (error) {
        onError(null, error);
    }
}

/**
* Obtener InmaculadaFem Jornadas
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getInmaculadaFemJornadas(onSuccess, onError) {
    try {
        onSnapshot(queryJornadasInmaculadaFem, (snapshot) => {
            const jornadas = [];
            snapshot.forEach((doc) => {
                jornadas.push(doc.data());
            });
            onSuccess(jornadas)
        });
        
    } catch (error) {
        onError(null, error);
    }
}

/**
* Obtener InmaculadaA Patrocinadores
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getInmaculadaAPatrocinadores(onSuccess, onError) {
    try {
        onSnapshot(queryPatrocinadoresInmaculadaA, (snapshot) => {
            const patrocinadores = [];
            snapshot.forEach((doc) => {
                patrocinadores.push(doc.data());
            });
            onSuccess(patrocinadores)
        });
        
    } catch (error) {
        onError(null, error);
    }
}

/**
* Obtener InmaculadaB Patrocinadores
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getInmaculadaBPatrocinadores(onSuccess, onError) {
    try {
        onSnapshot(queryPatrocinadoresInmaculadaB, (snapshot) => {
            const patrocinadores = [];
            snapshot.forEach((doc) => {
                patrocinadores.push(doc.data());
            });
            onSuccess(patrocinadores)
        });
        
    } catch (error) {
        onError(null, error);
    }
}

/**
* Obtener InmaculadaFem Patrocinadores
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getInmaculadaFemPatrocinadores(onSuccess, onError) {
    try {
        onSnapshot(queryPatrocinadoresInmaculadaFem, (snapshot) => {
            const patrocinadores = [];
            snapshot.forEach((doc) => {
                patrocinadores.push(doc.data());
            });
            onSuccess(patrocinadores)
        });
        
    } catch (error) {
        onError(null, error);
    }
}

const equiposNombre = ["A.A. INMACULADA 'A' - RV MEDICINA ESTETICA","AGENCIA ASTURIAS COSTA NORTE","ALIMERKA OVIEDO BALONCESTO",
    "ASTURIANA DE REPARACIONES BVM2012","C.B. LA ARGAÑOSA","C.D.B. AVILES SUR \'A\'","CENTRO ASTURIANO OVIEDO",
    "OKTICKET CIRCULO GIJON U22","CONFIA CD ART-CHIVO", "DOROTEAS ATLETICA AVILESINA", "GIJON BASKET 2015 CORPI",
    "REAL GRUPO DE CULTURA COVADONGA","SANFER ADBA"
        ]

const equiposEscudo= ["https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-inmaculada.jpg?alt=media&token=bc6af098-70fb-4480-b88f-42f791a3a079",
    "https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-costaNorte.jpg?alt=media&token=0046202f-c25f-4a33-8e3c-abacccf62487",
    "https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-oviedo.jpg?alt=media&token=4d002a7d-3c97-4985-9a65-20b3f6de669c",
    "https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-mieres.jpg?alt=media&token=ca8dc677-c230-416e-953b-d9cf0ee9fc01",
    "https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-arga%C3%B1osa.jpg?alt=media&token=591552df-08d4-4078-93a1-553f44d8b51d",
    "https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-avilessur.jpg?alt=media&token=c081dc33-b7c4-44f9-a58e-23db599b82e5",
    "https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-cao.jpg?alt=media&token=a8fe13b1-cb6b-45f4-8d61-733f69b52958",
    "https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-circulo.jpg?alt=media&token=db322e97-ff64-43fb-8215-195452bcd14a",
    "https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-artchivo.png?alt=media&token=23064ec5-4a32-4e4c-bd01-afd61f079874",
    "https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-avilesina.JPG?alt=media&token=b1c0aed5-6a14-4352-9a28-056549e8718c",
    "https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-gijonbasket.jpeg?alt=media&token=e3f4b7ec-a8f7-42a9-894e-13aee173ce3a",
    "https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-grupo.jpg?alt=media&token=8a2e3bca-242c-414a-8c3f-b7533570d413",
    "https://firebasestorage.googleapis.com/v0/b/aainmaculadabaloncesto.appspot.com/o/logosEquipos%2Flogo-sanfer.jpeg?alt=media&token=7ba670be-bea3-4e55-bceb-db324e7eff33",
]


/**
* Setear jugadores de cada equipo
* @param jugadores Jugadores de cada equipo
* @param equipo Nombre de cada equipo
*/
export async function setJugadoresEquipo(jugadores, equipo) {
    try {
        var i = equiposNombre.findIndex((a)=> a == equipo.trim())
        console.log(equipo.trim())
        jugadores.forEach(async (nombre)=>{
            await setDoc(doc(db, "fantasy","disponibles", "jugadores", nombre.trim()), {
                equipo: equipo.trim(),
                numero: "",
                nombre: nombre.trim(),
                mediaFantasyJornada: 0.0 ,
                escudoClub: equiposEscudo[i],
                puntosMvpJornada: [],
                puntosJornada: [],
                puntosEquipoJornada: [],
                puntosEquipo:[],
                foto:"",
              });
        })
    } catch (error) {
       console.log(error)
    }
}

/**
* Obtener todos los jugadores del fantasy
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getFantasyPlayers(onSuccess, onError) {
    try {
        onSnapshot(queryFantasyJugadores, (snapshot) => {
            const jugadoresFantasy = [];
            snapshot.forEach((doc) => {
                jugadoresFantasy.push(doc.data());
            });
            onSuccess(jugadoresFantasy)
        });
        
    } catch (error) {
        onError(null, error);
    }
}

/**
* Editar todos lo jugadores del fanatsy
* @param players Jugadores a editar
*/
export async function editPlayers(players) {
    try {
        players.forEach(async (jugador)=>{
           /* await setDoc(doc(db, "fantasy","disponibles", "jugadores", jugador.nombre), {
                equipo: jugador.equipo,
                numero: jugador.numero,
                nombre: jugador.nombre,
                mediaFantasyJornada: jugador.mediaFantasyJornada ,
                escudoClub: jugador.escudoClub,
                puntosJornada: jugador.puntosJornada,
                vecesEquipoJornada: jugador.vecesEquipoJornada,
                vecesMvp: 0,
              });
            }*/
              await updateDoc(doc(db, "fantasy","disponibles", "jugadores", jugador.nombre), {
                vecesMvp: 0,
              });
        })
    } catch (error) {
        console.log(error)
    }
}


/**
* Obtener todos los equipos del fantasy
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getFantasyTeams(onSuccess, onError) {
    try {
        onSnapshot(queryFantasyEquipos, (snapshot) => {
            const equiposFantasy = [];
            snapshot.forEach((doc) => {
                equiposFantasy.push(doc.data());
            });
            onSuccess(equiposFantasy)
        });
        
    } catch (error) {
        onError(null, error);
    }
}

/**
* Obtener todos los participantes del fantasy
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getFantasyParticipantes(onSuccess, onError) {
    try {
        onSnapshot(queryFantasyParticipantes, (snapshot) => {
            const participantesFantasy = [];
            snapshot.forEach((doc) => {
                participantesFantasy.push(doc.data());
            });
            onSuccess(participantesFantasy)
        });
        
    } catch (error) {
        onError(null, error);
    }
}

/**
* Obtener el número de jornada del fantasy
* @param onSuccess Función a ejecutar en caso de éxito en la llamada al servicio web
* @param onError Función a ejecutar en caso de error en la llamada al servicio web
*/
export async function getFantasyConfig(onSuccess, onError) {
    try {
        onSnapshot(queryFantasyConfig, (doc) => {
            onSuccess(doc.data());
        });
    } catch (error) {
        onError(null, error);
    }
}

/**
* Inicializa un usuario cuando se registra
*/

export async function initializeUser(id) {
    try {
        await setDoc(doc(db, "fantasy","usuarios", "participantes", id), {
            puntosJornada:[],
            puntosEquipo:[],
            posicionesJornadas:[],
            nombre: "Jugador",
            puntosTotal:0,
            id: id,
            foto:""
        });
    } catch (error) {
        console.log(error)
    }
}

export async function updateParticipanteNombre(participanteId, nombre) {
    try {
        const nombreFormateado = nombre?.trim();

        if (!participanteId || !nombreFormateado) {
            throw new Error('Faltan datos para actualizar el nombre del participante');
        }

        const participanteDoc = doc(db, "fantasy","usuarios", "participantes", participanteId);
        await updateDoc(participanteDoc, { nombre: nombreFormateado });
    } catch (error) {
        console.error(error);
        throw error;
    }
}

/**
* Guarda el equipo en base de datos
*/
export async function saveTeam(id, jugadores, jornada) {
    try {
        jugadores.forEach(async (jugador, index)=>{
            await setDoc(doc(db, "fantasy","usuarios", "participantes", id,"equipo"+(jornada), "jugador"+(index +1)), {
                equipo: jugador.equipo,
                numero: jugador.numero,
                nombre: jugador.nombre,
                foto: jugador.foto,
                mediaFantasyJornada: jugador.mediaFantasyJornada ,
                escudoClub: jugador.escudoClub,
                puntosJornada: jugador.puntosJornada,
                puntosEquipoJornada: jugador.puntosEquipoJornada,
                puntosMvpJornada: jugador.puntosMvpJornada,
            });
        })
        await setDoc(doc(db, "fantasy","usuarios", "participantes", id,"equipo"+(jornada), "config"), {
            capitan: jugadores[0].nombre,
            sextoHombre:jugadores[jugadores.length -1].nombre,
        });
    } catch (error) {
        console.log(error)
    }
}

/**
* Obtener el equipo de un usuario
*/
export async function getUserTeam(id,jornada,onSuccess, onError) {
    try {
        onSnapshot(query(collection(db, "fantasy","usuarios", "participantes", id, "equipo"+(jornada))), (snapshot) => {
            const jugadoresUsuario = [];
            snapshot.forEach((doc) => {
                jugadoresUsuario.push(doc.data());
            });
            onSuccess(jugadoresUsuario)
        });
    } catch (error) {
        onError(null, error);
    }
}

/**
* Seleccionar capitan y sexto hombre
*/
export async function saveConfig(id, config, jornada) {
    try {
        await setDoc(doc(db, "fantasy","usuarios", "participantes", id,"equipo"+(jornada), "config"), {
            capitan: config.capitan,
            sextoHombre:config.sextoHombre,
        });
    } catch (error) {
        console.log(error)
        throw error
    }
}

/**
* Dar puntos a los jugadores
* @param players Jugadores a editar
*/
export async function givePointsToPlayers(jugador, puntuacion, player) {
    try {
        
            var b = jugador.puntosJornada
            b.push(puntuacion)
         /* 
            await updateDoc(doc(db, "fantasy","disponibles", "jugadores", jugador.nombre.trim()), {
                puntosJornada: b,
            });
        */
    } catch (error) {
        console.log(error)
        console.log(player)
/*
        var i = equiposNombre.findIndex((a)=> a == player.team.trim())
        await setDoc(doc(db, "fantasy","disponibles", "jugadores", player.name.trim()), {
            equipo: player.team.trim(),
            numero: player.num,
            nombre: player.name.trim(),
            mediaFantasyJornada: 0,
            escudoClub: equiposEscudo[i],
            puntosJornada: [0,0,0,0],
            puntosEquipoJornada: [0,0,0,0],
            puntosMvpJornada: [0,0,0,0],
            foto: "",
          });*/
    }
}

export async function editPlayerPrueba(players) {
    try {
        players.forEach(async (jugador)=>{
              await updateDoc(doc(db, "fantasy","disponibles", "jugadores", jugador.nombre.trim()), {
                vecesEquipoJornada: deleteField(),
                vecesMvp: deleteField(),
                puntosEquipoJornada: [0],
                puntosMvpJornada: [0],
              });
        })//arrayUnion(6)
    } catch (error) {
        console.log(error)
    }
}

export async function setTeamOfTheWeek(bestTeam, jornada) {
    try {
        bestTeam.forEach(async (jugador, index)=>{
            if(index == 0){
                var a = jugador.puntosMvpJornada
                a.push(10)
              await updateDoc(doc(db, "fantasy","disponibles", "jugadores", jugador.nombre.trim()), {
                puntosMvpJornada: a,
              });
            } else {
                var b = jugador.puntosEquipoJornada
                b.push(5)
                await updateDoc(doc(db, "fantasy","disponibles", "jugadores", jugador.nombre.trim()), {
                    puntosEquipoJornada: b,
                  });
            }
        })//arrayUnion(6)
    } catch (error) {
        console.log(error)
    }
}

export async function ajustarArraysJornada(players, jornada) {
    try {
        players.forEach(async (jugador, index)=>{
            if(jugador.puntosJornada[jornada] == null){
                console.log(jugador)
                var a = jugador.puntosJornada
                a.push(0)
              await updateDoc(doc(db, "fantasy","disponibles", "jugadores", jugador.nombre.trim()), {
                puntosJornada: a,
              });
            }
            if(jugador.puntosMvpJornada[jornada] == null){
                var b = jugador.puntosMvpJornada
                b.push(0)
                await updateDoc(doc(db, "fantasy","disponibles", "jugadores", jugador.nombre.trim()), {
                  puntosMvpJornada: b,
                });
            }
            if(jugador.puntosEquipoJornada[jornada] == null){
                var c = jugador.puntosEquipoJornada
                c.push(0)
            await updateDoc(doc(db, "fantasy","disponibles", "jugadores", jugador.nombre.trim()), {
                puntosEquipoJornada:c,
            });
            }
        })
    } catch (error) {
        console.log(error)
    }
}

export async function calcularMedia(jugadores) {
    try {
        jugadores.forEach(async (jugador)=>{
            await updateDoc(doc(db, "fantasy","disponibles", "jugadores", jugador.nombre.trim()), {
                mediaFantasyJornada: getMediaPuntos(jugador),
            });
        })
    } catch (error) {
        console.log(error)
    }
}

export async function ordenarJornada(jugadores) {
    try {
        jugadores.forEach(async (jugador)=>{
            var newPuntosJornada = [jugador.puntosJornada[0],jugador.puntosJornada[1],jugador.puntosJornada[2],jugador.puntosJornada[3],jugador.puntosJornada[4],jugador.puntosJornada[5],jugador.puntosJornada[6],jugador.puntosJornada[7],jugador.puntosJornada[8],jugador.puntosJornada[9],jugador.puntosJornada[10],jugador.puntosJornada[11],jugador.puntosJornada[12],jugador.puntosJornada[13],jugador.puntosJornada[14],jugador.puntosJornada[15],jugador.puntosJornada[16],jugador.puntosJornada[17],jugador.puntosJornada[18],jugador.puntosJornada[20],jugador.puntosJornada[19]]
            var newPuntosEquipoJornada = [jugador.puntosEquipoJornada[0],jugador.puntosEquipoJornada[1],jugador.puntosEquipoJornada[2],jugador.puntosEquipoJornada[3],jugador.puntosEquipoJornada[4],jugador.puntosEquipoJornada[5],jugador.puntosEquipoJornada[6],jugador.puntosEquipoJornada[7], jugador.puntosEquipoJornada[8], jugador.puntosEquipoJornada[9],jugador.puntosEquipoJornada[10],jugador.puntosEquipoJornada[11],jugador.puntosEquipoJornada[12],jugador.puntosEquipoJornada[13],jugador.puntosEquipoJornada[14],jugador.puntosEquipoJornada[15],jugador.puntosEquipoJornada[16],jugador.puntosEquipoJornada[17],jugador.puntosEquipoJornada[18],jugador.puntosEquipoJornada[20],jugador.puntosEquipoJornada[19]]
            var newPuntosMvp = [jugador.puntosMvpJornada[0],jugador.puntosMvpJornada[1],jugador.puntosMvpJornada[2],jugador.puntosMvpJornada[3],jugador.puntosMvpJornada[4],jugador.puntosMvpJornada[5],jugador.puntosMvpJornada[6],jugador.puntosMvpJornada[7],jugador.puntosMvpJornada[8],jugador.puntosMvpJornada[9],jugador.puntosMvpJornada[10],jugador.puntosMvpJornada[11],jugador.puntosMvpJornada[12],jugador.puntosMvpJornada[13],jugador.puntosMvpJornada[14],jugador.puntosMvpJornada[15],jugador.puntosMvpJornada[16],jugador.puntosMvpJornada[17],jugador.puntosMvpJornada[18],jugador.puntosMvpJornada[20],jugador.puntosMvpJornada[19]]
//CAMBIAR LOS ARRAY DE ARRIBA SI QUIERO CAMBIAR JORNADA
            await updateDoc(doc(db, "fantasy","disponibles", "jugadores", jugador.nombre.trim()), {
                puntosJornada: newPuntosJornada,
                puntosEquipoJornada: newPuntosEquipoJornada,
                puntosMvpJornada: newPuntosMvp,
            });
        })
    } catch (error) {
        console.log(error)
    }
}

export async function ordenarJornadaParticipantes(participantes) {
    try {
        participantes.forEach(async (participante)=>{
            var newPuntosJornada = [participante.puntosJornada[0],participante.puntosJornada[1],participante.puntosJornada[2],participante.puntosJornada[3],participante.puntosJornada[4],participante.puntosJornada[5],participante.puntosJornada[6],participante.puntosJornada[7],participante.puntosJornada[8],participante.puntosJornada[9],participante.puntosJornada[10],participante.puntosJornada[11],participante.puntosJornada[12],participante.puntosJornada[13],participante.puntosJornada[14],participante.puntosJornada[15],participante.puntosJornada[16],participante.puntosJornada[17],participante.puntosJornada[18],participante.puntosJornada[20],participante.puntosJornada[19]]
            var newPosicion = [participante.posicionesJornadas[0],participante.posicionesJornadas[1],participante.posicionesJornadas[2],participante.posicionesJornadas[3],participante.posicionesJornadas[4],participante.posicionesJornadas[5],participante.posicionesJornadas[6],participante.posicionesJornadas[7],participante.posicionesJornadas[8],participante.posicionesJornadas[9],participante.posicionesJornadas[10],participante.posicionesJornadas[11],participante.posicionesJornadas[12],participante.posicionesJornadas[13],participante.posicionesJornadas[14],participante.posicionesJornadas[15],participante.posicionesJornadas[16],participante.posicionesJornadas[17],participante.posicionesJornadas[18],participante.posicionesJornadas[20],participante.posicionesJornadas[19]]
            console.log(participante)
            //CAMBIAR LOS ARRAY DE ARRIBA SI QUIERO CAMBIAR JORNADA
           await updateDoc(doc(db, "fantasy","usuarios", "participantes", participante.id), {
               puntosJornada: newPuntosJornada,
                posicionesJornadas: newPosicion,
            });
        })
    } catch (error) {
        console.log(error)
    }
}




const getMediaPuntos = (jugador) =>{
    var media = 0
    jugador.puntosJornada.map((p)=>{
        media += p
    })
    return media/jugador.puntosJornada.length
}

export async function actualizarJugadoresDeParticipantes(idParticipante,jugadores,equipo, jornada) {
    try {
        jugadores.forEach(async (jugador)=>{
            if(equipo[1].nombre.trim() == jugador.nombre.trim() ){
                await updateDoc(doc(db, "fantasy","usuarios", "participantes", idParticipante,"equipo"+(jornada), "jugador1"), {
                    puntosEquipoJornada: jugador.puntosEquipoJornada,
                    puntosJornada: jugador.puntosJornada,
                    puntosMvpJornada: jugador.puntosMvpJornada,
                    mediaFantasyJornada:jugador.mediaFantasyJornada

                });
            } else if(equipo[2].nombre.trim() == jugador.nombre.trim() ){
                await updateDoc(doc(db, "fantasy","usuarios", "participantes", idParticipante,"equipo"+(jornada), "jugador2"), {
                    puntosEquipoJornada: jugador.puntosEquipoJornada,
                    puntosJornada: jugador.puntosJornada,
                    puntosMvpJornada: jugador.puntosMvpJornada,
                    mediaFantasyJornada:jugador.mediaFantasyJornada

                });
            } else if(equipo[3].nombre.trim() == jugador.nombre.trim() ){
                await updateDoc(doc(db, "fantasy","usuarios", "participantes", idParticipante,"equipo"+(jornada), "jugador3"), {
                    puntosEquipoJornada: jugador.puntosEquipoJornada,
                    puntosJornada: jugador.puntosJornada,
                    puntosMvpJornada: jugador.puntosMvpJornada,
                    mediaFantasyJornada:jugador.mediaFantasyJornada

                });
            } else if(equipo[4].nombre.trim() == jugador.nombre.trim() ){
                await updateDoc(doc(db, "fantasy","usuarios", "participantes", idParticipante,"equipo"+(jornada), "jugador4"), {
                    puntosEquipoJornada: jugador.puntosEquipoJornada,
                    puntosJornada: jugador.puntosJornada,
                    puntosMvpJornada: jugador.puntosMvpJornada,
                    mediaFantasyJornada:jugador.mediaFantasyJornada

                });
            } else if(equipo[5].nombre.trim() == jugador.nombre.trim() ){
                await updateDoc(doc(db, "fantasy","usuarios", "participantes", idParticipante,"equipo"+(jornada), "jugador5"), {
                    puntosEquipoJornada: jugador.puntosEquipoJornada,
                    puntosJornada: jugador.puntosJornada,
                    puntosMvpJornada: jugador.puntosMvpJornada,
                    mediaFantasyJornada:jugador.mediaFantasyJornada

                });
            } else if(equipo[6].nombre.trim() == jugador.nombre.trim() ){
                await updateDoc(doc(db, "fantasy","usuarios", "participantes", idParticipante,"equipo"+(jornada), "jugador6"), {
                    puntosEquipoJornada: jugador.puntosEquipoJornada,
                    puntosJornada: jugador.puntosJornada,
                    puntosMvpJornada: jugador.puntosMvpJornada,
                    mediaFantasyJornada:jugador.mediaFantasyJornada

                });
            } 
           
        })
    } catch (error) {
        console.log(error)
    }
}

export async function darPuntosParticipantes(id, puntosEquipo, jornada, participante) {
    try {
        const indiceJornada = Math.max(0, Number(jornada));
        console.log(puntosEquipo)
        const puntos = Array.isArray(participante?.puntosEquipo)
            ? [...participante.puntosEquipo]
            : [];
        puntos[indiceJornada] = Number(puntosEquipo);
        await updateDoc(doc(db, "fantasy","usuarios", "participantes", id), {
            puntosEquipo: puntos,
        });
    } catch (error) {
        console.log(error)
    }
}

/**
 * Reparte los puntos de clasificación de una jornada y guarda la posición final.
 * El último recibe 0, los puestos anteriores suman 1 por puesto y el podio
 * recibe 2 puntos para el tercero y segundo, y 3 para el primero.
 */
export async function clasificarParticipantesJornada(jornada) {
    try {
        const indiceJornada = Math.max(0, Number(jornada));
        console.log(`Clasificando participantes para la jornada ${jornada} (índice ${indiceJornada})`);
        const snapshot = await getDocs(queryFantasyParticipantes);
        const participantes = snapshot.docs
            .map((participanteDoc) => participanteDoc.data())
            .sort((a, b) => {
                const puntosA = Number(a.puntosEquipo?.[indiceJornada] ?? 0);
                const puntosB = Number(b.puntosEquipo?.[indiceJornada] ?? 0);
                return puntosA - puntosB;
            });
            console.log(participantes)

        await Promise.all(participantes.map(async (participante, index) => {
            const posicion = participantes.length - index;
            const puntosEquipoJornada = Number(participante.puntosEquipo?.[indiceJornada] ?? 0);
            const puntosJornada = Array.isArray(participante.puntosJornada)
                ? [...participante.puntosJornada]
                : [];
            const posicionesJornadas = Array.isArray(participante.posicionesJornadas)
                ? [...participante.posicionesJornadas]
                : [];
            const puntosAnteriores = puntosJornada.reduce((total, puntos, indice) => (
                indice === indiceJornada ? total : total + Number(puntos ?? 0)
            ), 0);
            const puntosClasificacion = puntosEquipoJornada === 0 ? 0 :
                    posicion === 1 ? index + 4
                : posicion === 2 ? index + 2
                : posicion === 3 ? index + 1
                    : index;
            puntosJornada[indiceJornada] = puntosClasificacion;
            posicionesJornadas[indiceJornada] = puntosEquipoJornada === 0 || posicion === participantes.length
                ? -1
                : posicion;
            console.log(`Participante: ${participante.nombre}, Puntos Jornada: ${puntosJornada[indiceJornada]}, Posición: ${posicion}, Puntos Clasificación: ${puntosClasificacion}, Puntos Anteriores: ${puntosAnteriores}`);
            const puntosTotal = puntosAnteriores + puntosClasificacion;
            console.log(puntosJornada, posicionesJornadas, puntosTotal)

            await updateDoc(doc(db, "fantasy", "usuarios", "participantes", participante.id), {
                puntosJornada,
                posicionesJornadas,
                puntosTotal,
            });
        }));

        return participantes;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
